import React from "react";
import { Check } from "lucide-react";

export const WIZARD_STEPS = [
  { step: 1, label: "DÖF Bilgileri" },
  { step: 2, label: "Uygunsuzluk ve Atama" },
  { step: 3, label: "Kök Neden ve Faaliyetler" },
  { step: 4, label: "Takip ve Karar" },
];

function DofWizardSteps({ currentStep, onSelect, steps = WIZARD_STEPS }) {
  return (
    <div className="dof-wizard-steps" style={{ gridTemplateColumns: `repeat(${steps.length}, minmax(0, 1fr))` }}>
      {steps.map((item) => {
        const active = currentStep === item.step;
        const done = currentStep > item.step;
        return (
          <button
            type="button"
            key={item.step}
            className={`dof-wizard-step ${active ? "active" : ""} ${done ? "done" : ""}`}
            onClick={() => onSelect(item.step)}
          >
            <b>{done ? <Check size={15} /> : item.step}</b>
            <span>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default DofWizardSteps;
